import { Stack, Tooltip, Typography } from "@mui/material";

export const SlideLabelValue = ({
  label,
  isMissing,
  children,
  labelMinWidth,
  labelTooltip,
  ...props
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      justifyContent={"space-between"}
      {...props}
    >
      <Tooltip title={labelTooltip || ""}>
        <Typography
          flexShrink={1}
          minWidth={labelMinWidth || 30}
          variant="body2"
        >
          {label}
        </Typography>
      </Tooltip>
      <Typography variant="body2" textAlign={"right"}>
        {children}
      </Typography>
    </Stack>
  );
};

export default SlideLabelValue;
